<template>
  <div
    v-if="isDesktop && tilesWithProducts.length"
    :style="`margin-bottom: ${tilesMB}px;`"
    :class="$b({ desktop: true })"
  >
    <ArticleProductTile
      v-for="(tile, index) in tilesWithProducts"
      :key="index"
      :title="tile.title"
      :product="tile.product"
    />
  </div>

  <div
    v-else-if="tilesWithProducts.length"
    :class="$b({ mobile: true })"
    :style="`margin-bottom: ${tilesMB}px;`"
  >
    <div :class="$b('carousel')">
      <div
        v-for="resolvedProduct in resolvedProducts"
        :key="resolvedProduct.sku"
        :class="$b('carousel-item')"
      >
        <ProductData
          v-if="resolvedProducts.length"
          :products="[resolvedProduct]"
        >
          <template #default="{ products }">
            <ArticleTileProductCard
              :products="products"
            />
          </template>
        </ProductData>
      </div>
    </div>
  </div>
</template>

<script>
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '@/tailwind.config.js'
const resolvedConfig = resolveConfig(tailwindConfig)

export default {
  name: 'ArticleProductTiles',

  props: {
    tiles: {
      type: Array,
      required: true
    },

    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isDesktop: false,
      carousel: null,
      tilesMB: 0
    }
  },

  computed: {
    mediaQueryList () {
      return window.matchMedia(
        `(min-width: ${resolvedConfig.theme.screens.lg})`
      )
    },
    resolvedProducts () {
      return this.tilesWithProducts?.map(tile => ({
        ...tile.product,
        subTitle: tile.title
      })) || []
    },
    tilesWithProducts () {
      return this.tiles.filter(tile => tile.product)
    }
  },

  mounted () {
    this.mediaQueryListMatches()
    this.mediaQueryList.addListener(this.mediaQueryListMatches)

    this.setTilesBottomMargin()
  },

  beforeUnmount () {
    this.timeoutOut = setTimeout(() => {
      if (this.carousel) this.carousel.destroy()
    }, 250)
  },

  unmounted () {
    this.mediaQueryList.removeListener(this.mediaQueryListMatches)
  },

  methods: {
    mediaQueryListMatches () {
      this.isDesktop = this.mediaQueryList.matches
      if (this.isDesktop) this.setTilesBottomMargin()
    },

    setTilesBottomMargin () {
      if (!document || !this.isDesktop) return 0

      const figcaption = document.querySelector(`#${this.id} figcaption`)
      if (!figcaption) return 0

      const captionMargin = 24
      this.tilesMB = figcaption.offsetHeight + captionMargin
    }
  }
}
</script>

<style lang="postcss">
.ArticleProductTiles {
  @screen lg {
    position: absolute;
    bottom: 0;
    left: calc(0px - (var(--inner-gutter) * 3 + var(--column-width) * 3));
    width: calc((var(--column-width) * 2) + var(--inner-gutter));
  }

  &--mobile {
    @apply mt-sm -ml-[var(--outer-gutter)]
      w-[calc(100%+var(--outer-gutter)*2)]
      overflow-hidden;
  }

  &__carousel {
    @apply flex scrollbar-none overflow-x-auto pl-[var(--outer-gutter)];
  }

  &__carousel-item {
    @apply grow shrink-0 mr-sm w-1/2 max-w-[240px]
  }
}

.ArticleProductTiles .ArticleProductTile:not(:last-of-type) {
  @apply lg:mb-7;
}
</style>
